"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EVENTS = exports.ENV = void 0;
var ENV;
(function (ENV) {
    ENV["PROD"] = "prod";
    ENV["STAGING"] = "staging";
    ENV["DEV"] = "dev";
    /**
     * **This is for local development only**
     */
    ENV["LOCAL"] = "local";
})(ENV = exports.ENV || (exports.ENV = {}));
exports.EVENTS = {
    // Websocket
    CONNECT: 'connect',
    DISCONNECT: 'disconnect',
    // Notification
    USER_FEEDS: 'userFeeds',
    USER_SPAM_FEEDS: 'userSpamFeeds',
    // Chat
    CHAT_RECEIVED_MESSAGE: 'CHATS',
    CHAT_GROUPS: 'CHAT_GROUPS'
};
//# sourceMappingURL=constants.js.map